import { useEffect, useState } from "react";
import { classNames, ranksFormatted } from "../../utils/Helper";
import TemporaryDrawer from "../ui/temp-drawer.component";
import { CollectibleIcon } from "../ui/collectible-icon";
import { GemsIcon } from "../ui/gems-icon";
import BoostUpIcon from "../svg/BoostUpIcon";
import { BoostItemIcon } from "../shop/gems-buyable-items.component";
import { BoostIcon } from "../svg/BoostIcon";
import LeagueRewardIcon from "./league-rewards-icons.components";
import { TripleStarIcon } from "../ui/triple-star-icon";

import {useGetTournamentRewardsQuery} from "../../apis/tournaments.api";

interface LiguePrizesProps {

}

const LiguePrizes: React.FC<LiguePrizesProps> = () => {

  const [showDrawer, setShowDrawer] = useState(false);

  const [ironLeagueRewards, setIronLeagueRewards] = useState([] as any);
  const [bronzeLeagueRewards, setBronzeLeagueRewards] = useState([] as any);

  // const bronzeLeagueRewards = [
  //   {
  //     ranks: [1],
  //     rewards: [
  //       {
  //         value: 1,
  //         type: "silver-collectible",
  //       },
  //       {
  //         value: 1,
  //         type: "bronze-collectible",
  //       },
  //       {
  //         value: 15,
  //         type: "crypto",
  //       },
  //       {
  //         value: 50,
  //         type: "gems",
  //       },
  //       {
  //         value: 1,
  //         type: "power-up",
  //       }
  //     ]
  //   },
  //   {
  //     ranks: [2],
  //     rewards: [
  //       {
  //         value: 1,
  //         type: "silver-collectible",
  //       },
  //       {
  //         value: 1,
  //         type: "bronze-collectible",
  //       },
  //       {
  //         value: 10,
  //         type: "crypto",
  //       },
  //       {
  //         value: 25,
  //         type: "gems",
  //       },
  //       {
  //         value: 1,
  //         type: "power-up",
  //       }
  //     ]
  //   },
  //   {
  //     ranks: [3],
  //     rewards: [
  //       {
  //         value: 1,
  //         type: "silver-collectible",
  //       },
  //       {
  //         value: 1,
  //         type: "bronze-collectible",
  //       },
  //       {
  //         value: 5,
  //         type: "crypto",
  //       },
  //       {
  //         value: 10,
  //         type: "gems",
  //       },
  //       {
  //         value: 1,
  //         type: "power-up",
  //       }
  //     ]
  //   },
  //   {
  //     ranks: [4, 5],
  //     rewards: [
  //       {
  //         value: 1,
  //         type: "bronze-collectible",
  //       },
  //       {
  //         value: 5,
  //         type: "gems",
  //       },
  //       {
  //         value: 1,
  //         type: "power-up",
  //       }
  //     ]
  //   },
  //   {
  //     ranks: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
  //     rewards: [
  //       {
  //         value: 1,
  //         type: "power-up",
  //       }
  //     ]
  //   }
  // ];

  // const ironLeagueRewards = [
  //   {
  //     ranks: [1],
  //     rewards: [
  //       {
  //         value: 1,
  //         type: "bronze-collectible",
  //       },
  //       {
  //         value: 15,
  //         type: "gems",
  //       },
  //       {
  //         value: 1,
  //         type: "power-up",
  //       }
  //     ]
  //   },
  //   {
  //     ranks: [2],
  //     rewards: [
  //       {
  //         value: 1,
  //         type: "bronze-collectible",
  //       },
  //       {
  //         value: 10,
  //         type: "gems",
  //       },
  //       {
  //         value: 1,
  //         type: "power-up",
  //       }
  //     ]
  //   },
  //   {
  //     ranks: [3],
  //     rewards: [
  //       {
  //         value: 1,
  //         type: "bronze-collectible",
  //       },
  //       {
  //         value: 5,
  //         type: "gems",
  //       },
  //       {
  //         value: 1,
  //         type: "power-up",
  //       }
  //     ]
  //   },
  //   {
  //     ranks: [4,5],
  //     rewards: [
  //       {
  //         value: 1,
  //         type: "bronze-collectible",
  //       },
  //       {
  //         value: 3,
  //         type: "gems",
  //       },
  //       {
  //         value: 1,
  //         type: "power-up",
  //       }
  //     ]
  //   },
  //   {
  //     ranks: [6,7,8,9,10],
  //     rewards: [
  //       {
  //         value: 3,
  //         type: "gems",
  //       },
  //       {
  //         value: 1,
  //         type: "power-up",
  //       }
  //     ]
  //   },
  //   {
  //     ranks: [11,12,13,14,15,16,17,18,19,20],
  //     rewards: [
  //       {
  //         value: 1,
  //         type: "power-up",
  //       }
  //     ]
  //   }
  // ];

  const {data: rewardsData, isLoading: areRewardsLoading} = useGetTournamentRewardsQuery();

  useEffect(() => {
    if(rewardsData){
      setIronLeagueRewards(rewardsData[0]);
      setBronzeLeagueRewards(rewardsData[1]);
    }
  }, [rewardsData]);

  return (

    <>

      <div className={classNames("relative")} onClick={(e) => {
        setShowDrawer(true);
        e.stopPropagation();
      }}>

        <div className="nav-bar-button  w-8 h-[30px] center" > i </div>

      </div>

      <TemporaryDrawer
        title={`Prizes`}
        closeWhenClickingOutside={true}
        anchor={'bottom'}
        open={showDrawer}
        lineIcon={false}
        size={"auto"}
        onClose={() => {
          setShowDrawer(false);
        }
      }>
        <div className={"w-full h-full flex flex-col justify-between items-center py-2 overflow-y-auto"}>

          <div>

            <div className={"flex flex-col gap-y-2 items-center mb-4"}>
              <TripleStarIcon/>
            </div>

            <div className={"flexjustify-center"}>

              <p className={"font-normal text-center"}>
                Top players of each league can earn big rewards!
              </p>

            </div>

            <div className={"flex flex-col items-center mt-4"}>

              <p className={"text-md center mb-2"}>
                Bronze League
              </p>

                { !areRewardsLoading && bronzeLeagueRewards.map( (stepLine:any, index:number) => {
                  return (

                    <div key={index} className="w-full flex gap-2 items-center py-2 border-t last:border-b border-gray-700">

                      <div className="border-r border-gray-700 min-w-[55px] center">
                        <p className="pr-2"> #{ranksFormatted(stepLine.ranks)}</p>
                      </div>

                      <div className="flex grow gap-2">

                        { stepLine.rewards.map( (reward:any, index:number) => {
                          return(
                            <div key={index} className="flex items-center gap-1">
                              {reward.value} <LeagueRewardIcon type={reward.type}/>
                            </div>
                          )
                        })}

                      </div>

                    </div>

                  )
                })}

            </div>

            <div className={"flex flex-col items-center mt-4"}>

              <p className={"text-md center mb-2"}>
                Iron League
              </p>

                { !areRewardsLoading && ironLeagueRewards && ironLeagueRewards.map( (stepLine:any, index:number) => {
                  return (

                    <div key={index} className="w-full flex gap-2 items-center py-2 border-t last:border-b border-gray-700">

                      <div className="border-r border-gray-700 min-w-[55px] center">
                        <p className="pr-2"> #{ranksFormatted(stepLine.ranks)}</p>
                      </div>

                      <div className="flex grow gap-2">

                        { stepLine.rewards.map( (reward:any, index:number) => {
                          return(
                            <div key={index} className="flex items-center gap-1">
                              {reward.value} <LeagueRewardIcon type={reward.type}/>
                            </div>
                          )
                        })}

                      </div>

                    </div>

                  )
                })}

            </div>

          </div>

        </div>
      </TemporaryDrawer>

    </>


   );
}

export default LiguePrizes;